import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "utils/functions";

const appCardVariants = cva("border border-gray-300 rounded-xl p-4", {
  variants: {
    variant: {
      solid: "border-solid",
      dashed: "border-dashed",
    },
    color: {
      white: "bg-white",
      "gray-50": "bg-gray-50",
      "gray-100": "bg-gray-100",
    },
    shadow: {
      none: "",
      md: "shadow-md",
    },
  },
  defaultVariants: {
    color: "white",
    variant: "solid",
    shadow: "none",
  },
});
export interface AppCardProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "color">, VariantProps<typeof appCardVariants> {}

function AppCard({ className, color, variant, shadow, ...props }: AppCardProps) {
  return <div className={cn(appCardVariants({ color, variant, shadow }), className)} {...props} />;
}

function OnboardingSteps({ status, ...props }: AppCardProps & { status: "done" | "current" | "pending" }) {
  return (
    <AppCard
      {...props}
      color={status === "pending" ? "gray-50" : "white"}
      shadow={status === "current" ? "md" : "none"}
      className={cn(props.className, "p-3 flex items-center gap-3")}
    />
  );
}

AppCard.OnboardingSteps = OnboardingSteps;

export { AppCard };
